import React from "react";
import Container from "./container";
import { cn } from "../lib/helpers";
import { imageUrlFor } from "../lib/image-url";
import { buildImageObj } from "../lib/helpers";
import Slider from "react-slick"

import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import "../styles/common/slider-theme.css"
import * as styles from "../styles/components/testimonials-section.module.css";

const TestimonialsSection = (props) => {

  const {
    heading,
    testimonials
  } = props;

  const sliderSettings = {
    dots: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
        {
          breakpoint: 1200,
          settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
          },
        },
        {
          breakpoint: 700,
          settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
          }
        }
    ]
  }

  return (
    <div className={styles.root}>
      <Container>
        {heading && <h2 className={cn("h3", styles.heading)}>{heading}</h2>}
      </Container>
      {(testimonials && testimonials.length) 
        ? <div className={styles.inner}><Slider {...sliderSettings} className={styles.slider}>
            {testimonials.map(({ testimonial, _key }) => {
            return (
                <div key={_key} className={styles.item}>
                  <div>
                    {testimonial.logo && testimonial.logo.asset && 
                        <div className={styles.logo}>
                        <img
                            src={imageUrlFor(buildImageObj(testimonial.logo))
                            .auto("format")
                            .url()}
                            alt={testimonial.company}
                        />
                        </div>
                    }
                    {testimonial.content && <p>{testimonial.content}</p>}
                </div>
                <div className={styles.meta}>
                    <div className={styles.headshot}>
                    {testimonial.headshot && testimonial.headshot.asset && 
                        <img
                        src={imageUrlFor(buildImageObj(testimonial.headshot))
                            .auto("format")
                            .url()}
                        alt={testimonial.author}
                        />
                    }
                    </div>
                    {testimonial.author && <div className={styles.author}>{testimonial.author}</div>}
                    {testimonial.position && <div className={styles.position}>{testimonial.position}</div>}
                    {testimonial.company && <div className={styles.company}>{testimonial.company}</div>}
                </div>
                </div>
            );
            })}
          </Slider></div>
        : null
      }
    </div>
  );
}

export default TestimonialsSection;
